import React from 'react';

import { Box, Typography } from '@mui/material';

import type { ScheduleRecord } from '~/services/OffersService';

import AppOnlyFlashEventCard from './AppOnlyFlashEventCard';
import { CalendarDay } from './appOnlyFlashCalendar';

interface Props {
  day: CalendarDay;
  isToday: boolean;
  isPast: boolean;
  schedules: Array<ScheduleRecord>;
  offersById: Map<string, App.Offer>;
  loadingOfferIds: Set<string>;
}

export default function AppOnlyFlashCalendarDay({
  day,
  isToday,
  isPast,
  schedules,
  offersById,
  loadingOfferIds,
}: Props) {
  return (
    <Box
      sx={{
        minHeight: 132,
        p: 0.75,
        borderRight: 1,
        borderBottom: 1,
        borderColor: 'divider',
        '&:nth-of-type(7n)': { borderRight: 0 },
        bgcolor: isPast ? 'grey.100' : day.inMonth ? 'background.paper' : 'grey.50',
        minWidth: 0,
      }}
    >
      <Box
        sx={{
          width: 25,
          height: 25,
          mb: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          bgcolor: isToday ? 'primary.main' : 'transparent',
        }}
      >
        <Typography
          variant="caption"
          fontWeight={isToday ? 500 : 400}
          color={isToday ? 'primary.contrastText' : day.inMonth ? 'text.secondary' : 'text.disabled'}
        >
          {day.dayOfMonth}
        </Typography>
      </Box>
      {schedules.map((schedule) => (
        <AppOnlyFlashEventCard
          key={schedule.id}
          schedule={schedule}
          offer={offersById.get(schedule.fk_offer_salesforce_id)}
          isOfferLoading={loadingOfferIds.has(schedule.fk_offer_salesforce_id)}
        />
      ))}
    </Box>
  );
}
